import React, { useEffect, useState } from 'react';
import '../ChartsDashboard.css';
import { Col, Row } from 'react-bootstrap';
import * as chartjs from 'chart.js';
import ChartJSDataLabels from 'chartjs-plugin-datalabels';
import { DateTime } from 'luxon';
import { Bar } from 'react-chartjs-2';

chartjs.Chart.register(ChartJSDataLabels);

interface Props {
  cumulativeSales: {
    date: string,
    totalUSD: number,
    totalEUR: number,
    total: number
  }[];
  nDays: number;
}

const ChartSalesPastNDays = ({ cumulativeSales, nDays }: Props) => {
  const [data, setData] = useState<{ label: string[], totalEUR: number[], totalUSD: number[] }>({
    label: [],
    totalEUR: [],
    totalUSD: []
  });

  useEffect(() => {
    if (cumulativeSales) {
      const now = DateTime.now().endOf('day').toMillis();
      let lastNDays = DateTime.now().startOf('day').plus({ days: (nDays - 1) * -1 }).toMillis();

      const lastmonth = cumulativeSales.filter(cs => {
        const currentDataTime = new Date(cs.date).getTime();
        return currentDataTime >= lastNDays && currentDataTime <= now;
      });

      const labels: string[] = [];

      let totalUSD: number[] = [];
      let totalEUR: number[] = [];

      while (lastNDays <= now) {
        const datetime = DateTime.fromMillis(lastNDays, { zone: 'Europe/Paris' });
        const date = datetime.toFormat('yyyy-MM-dd');
        const dataMonth = lastmonth.find((lm: any) => {
          const dateString = DateTime.fromJSDate(new Date(lm.date), { zone: 'Europe/Paris' })
            .toFormat('yyyy-MM-dd');
          return dateString === date;
        });
        totalEUR.push(dataMonth?.totalEUR || 0);
        totalUSD.push(dataMonth?.totalUSD || 0);
        const label = datetime.toFormat('dd MMM');
        console.log(label);
        labels.push(label);
        setData({ label: labels, totalUSD: totalUSD, totalEUR: totalEUR });
        lastNDays = DateTime.fromMillis(lastNDays, { zone: 'Europe/Paris' }).plus({ days: 1 }).toMillis();
      }
    }
  }, []);

  const io = ' €';
  const us = ' $';

  const options = {
    plugins: {
      datalabels: {
        display: true,
        color: 'transparent',
        formatter: (value: any, ctx: any) => {
          if (ctx.dataset.label === '.io') {
            return `${Math.round(data.totalEUR[ctx.dataIndex] * 100) / 100} ${io}`;
          } else {
            return `${Math.round(data.totalUSD[ctx.dataIndex] * 100) / 100} ${us}`;
          }
        }
      }
    },
    legend: {
      display: true,
      font: {
        weight: 'bold',
        size: 16
      }
    }
  };

  return (
    <>
      <Row>
        <Col>
          <div  >{cumulativeSales ? <Bar data={{
            labels: data.label.map(d => d),
            datasets: [
              {
                label: '.io',
                data: data.totalEUR.map(d => d || 0),
                backgroundColor: 'rgb(54, 162, 235)'
              },
              {
                label: '.us',
                data: data.totalUSD.map(d => d || 0),
                backgroundColor: 'rgb(75, 192, 192)'
              }
            ]
          }
          } options={options} /> : <p></p>}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ChartSalesPastNDays;
/* eslint-enable i18next/no-literal-string */
